module.exports = __webpack_public_path__ + "static/img/logo.921b303.png";